import {
    ScrollText,
    Mic,
    Bot,
    CalendarCheck,
    Receipt,
    MessageCircle,
    Rocket,
  } from "lucide-react";
  
  export default function FeaturePanel() {
    const features = [
      { icon: ScrollText, text: "View the Menu Anytime" },
      { icon: Mic, text: "Voice Notes Supported" },
      { icon: Bot, text: "Smart AI Assistant" },
      { icon: CalendarCheck, text: "Table Booking Made Easy" },
      { icon: Receipt, text: "Instant Order Summary" },
      { icon: MessageCircle, text: "Natural Chat Experience" },
      { icon: Rocket, text: "Fast & Reliable" },
    ];
  
    return (
      <div
        className="
          hidden md:flex 
          flex-col 
          w-72 
          bg-white/30 
          backdrop-blur-xl 
          border-r 
          border-purple-100 
          p-6 
          shadow-xl
        "
      >
        <h2 className="text-xl font-semibold text-purple-700 mb-6">
          Features
        </h2>
  
        <div className="space-y-4">
          {features.map((f, i) => (
            <div
              key={i}
              className="
                flex 
                items-center 
                gap-3 
                p-2 
                rounded-lg 
                hover:bg-purple-50 
                transition
              "
            >
              <f.icon size={20} className="text-purple-600" />
              <span className="text-sm text-gray-800">{f.text}</span>
            </div>
          ))}
        </div>
      </div>
    );
  }
  